var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.5 1031.8",
    style: {
      enableBackground: "new 0 0 728.5 1031.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F28",
    d: "M48.4,530.9h580.4l-96.9,88.9c-5.7,5.2-6.1,14.1-0.9,19.8c2.8,3,6.5,4.5,10.3,4.5c3.4,0,6.8-1.2,9.5-3.7 l123.4-113.2c2.9-2.7,4.4-6.2,4.5-9.9c0.7-4.5-0.7-9.3-4.3-12.6L551,391.5c-5.7-5.2-14.6-4.8-19.8,0.9c-5.2,5.7-4.8,14.6,0.9,19.8 l98.9,90.7H48.4c-7.7,0-14,6.3-14,14C34.4,524.7,40.7,530.9,48.4,530.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.46ad3049.svg";
export { ForwardRef as ReactComponent };